/**
 * RemarkCategoryEntity Class file
 *
 * Generated file, don't touch manually
 *
 * ModelVersion: 90001
 */
import { BaseEntity } from "@archipad-js/core/orm";
import { ProjectEntity } from "../ProjectEntity";
import { PersonEntity } from "../PersonEntity";
import { ProjectMemberEntity } from "../ProjectMemberEntity";
import { WorkPackageEntity } from "../WorkPackageEntity";
import { RemarkCategoryHierarchyEntity } from "../RemarkCategoryHierarchyEntity";
import { RemarkCategoryEntity } from "../RemarkCategoryEntity";
declare global {
    interface EntityTypeMap {
        RemarkCategory: RemarkCategoryEntity;
    }
}
export abstract class RemarkCategoryGeneratedEntity extends BaseEntity {
    public abstract remarkCategoryId: string;
    public abstract templateId: string | null;
    public abstract text: string | null;
    public abstract tag: number | null;
    public abstract displayName: string | null;
    public abstract project: ProjectEntity;
    public abstract visitor: PersonEntity | null;
    public abstract projectMember: ProjectMemberEntity | null;
    public abstract workPackage: WorkPackageEntity | null;
    public abstract contact: PersonEntity | null;
    public abstract readonly hierarchy: ReadonlyArray<RemarkCategoryHierarchyEntity>;
}
